import React,{useState,useRef,useEffect} from 'react'
import {
    Form,
  Input,
  Radio,
  Space,Toast,Dialog,
  Button,Selector,Ellipsis,Image,SideBar,NavBar,Tabs,FloatingBubble,Grid,InfiniteScroll,DotLoading,ImageViewer
} from 'antd-mobile-v5';
import dayjs from 'dayjs'
import { MessageOutline, LikeOutline,BellOutline,MessageFill,UploadOutline,ExclamationCircleFill } from 'antd-mobile-icons'
import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'
import { useNavigate,useParams,useLocation } from 'react-router-dom';
import {
    GetDataDictionarysByCode,PostAlbumClass,PostAlbums,GetPlanetInfo,InsertPlanetFamilyGroup,DelAlbumImgById
  } from '../../service/service';
import { environment } from '../../service/baseUrl';

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};


// 瀑布流项组件（不再控制高度）
const WaterfallItem = ({ item, navigate, planetId }) => {
    return (
        <div
            style={{
                backgroundColor: "#fff",
                borderRadius: 5,
                overflow: "hidden",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                marginTop: "12px"
            }}
            onClick={() => navigate('/albumInfo', { state: { planetId, id: item.id } })}
        >
            {/* 图片部分 - 高度由图片自身决定 */}
            <Image
                src={item.imgs[0] || ""}
                fit="cover"
                width="100%"
                style={{ display: 'block' }}
            />

            {/* 内容部分 - 高度由内容决定 */}
            <div style={{ padding: 8 }}>
                <div style={{
                    fontWeight: 600,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    lineHeight: "18px",
                    marginBottom: 8
                }}>
                    {item.remark || "暂无描述"}
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ flex: 1, display: "flex", alignItems: "center" }}>
                        <Image
                            src={item.headImg}
                            fit="cover"
                            width={20}
                            height={20}
                            style={{ borderRadius: "50%", marginRight: 6 }}
                        />
                        <span style={{ fontSize: 12 }}>{item.creatorUserName || "匿名用户"}</span>
                    </div>

                    <div style={{ display: "flex", alignItems: "center" }}>
                        <Image
                            src="https://api.weibinyi.com/images/niannian/1/1-18.png"
                            fit="cover"
                            width={15}
                            height={15}
                            style={{ marginRight: 4 }}
                        />
                        <span style={{ fontSize: 12 }}>{item.msgCount || 0}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

// 瀑布流项组件（不再控制高度）
const WaterfallItem2 = ({ item, viewImg }) => {
    return (
        <div
            style={{
                // backgroundColor: "#fff",
                borderRadius: 5,
                overflow: "hidden",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                marginTop: "12px"
            }}
            // onClick={() => navigate('/albumInfo', { state: { planetId, id: item.id } })}
            onClick={viewImg}
        >
            {/* 图片部分 - 高度由图片自身决定 */}
            <Image
                src={item || ""}
                fit="cover"
                width="100%"
                style={{ display: 'block' }}
            />

        </div>
    );
};

// 瀑布流项组件（不再控制高度）
const WaterfallItem3 = ({ item, viewImg, handleDelete }) => {
    return (
        <div
            style={{
                borderRadius: 5,
                overflow: "hidden",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                marginTop: "12px",
                // 外层容器不需要relative，让图片容器作为定位基准
            }}
            onClick={viewImg}
        >
            {/* 图片容器：必须设置relative，作为删除按钮的定位基准 */}
            <div style={{ position: "relative", width: "100%" }}>
                <Image
                    src={item.url || ""}
                    fit="cover"
                    width="100%"
                    style={{ display: "block" }} // 去除图片底部间隙
                />

                {/* 删除按钮：基于图片容器定位 */}
                {
                    item.isAdmin ?
                        <div
                            style={{
                                position: "absolute",
                                top: "5px", // 距离图片顶部8px
                                right: "5px", // 距离图片右侧8px
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                zIndex: 10, // 确保在图片上方
                                transition: "opacity 0.2s",
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleDelete();
                            }}
                        >
                            <Image
                                src="https://api.weibinyi.com/images/niannian/4/40-13.png"
                                fit="contain"
                                width="16px"
                                height="16px"
                                alt="删除"
                            />
                        </div> : null
                }
            </div>
        </div>
    );
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            id: 0,
            userInfo: {},

            tabIdx: 0,
            navIdx: 0,
            byIdx: 0,

            tabList: [],
            tabTypes: [],

            totalCount: 0,
            page: 0,
            pageSize: 10,
            hasMore: true,
            loading: false,
            albums: [],
            imgList: [],
            imgListQNY: [],

            isAdmin: false,
            planetInfo: {},
            visible1: false,
            demoImages: [],
            imgIndex: 0,
            
            dataLoading: false,
        };
    }

    componentDidMount() {
        console.log(this.props.userInfo);
        var that = this;

        const { location } = that.props;
        const { id } = location.state || {}; // 获取 URL 参数
        if (id) {
            that.setState({
                id: id, 
                dataLoading: true
            })

            GetPlanetInfo(id).then(res => {
                if (res.success) {
                    var isAdmin = false;
                    if (res.result.openId == localStorage.getItem("openid")) {
                        isAdmin = true;
                    } else {
                        var items = res.result.planetFamilyGroupDtos
                            .filter(x => x.openId == localStorage.getItem("openid"));
                        if (items.length > 0) {
                            isAdmin = items[0].isAdmin;
                        }
                    }

                    that.setState({
                        isAdmin: isAdmin,
                        planetInfo: res.result,
                    })
                }
            })

            that.insertPlanetFamilyGroup();
        }

        const searchParams = new URLSearchParams(window.location.search);
        const planetId = searchParams.get('planetId');

        GetDataDictionarysByCode("XiangCeLX").then(res => {
            if (res.success) {
                var arry = [];
                var tabIdx = 0;
                res.result.map((item, index) => {
                    if (planetId) {
                        tabIdx = 478;
                        that.setState({
                            tabIdx: 478
                        })
                    } else {
                        if (index == 0) {
                            tabIdx = item.id;
                            that.setState({
                                tabIdx: item.id
                            })
                        }
                    }
                    arry.push({ name: item.displayName, id: item.id })
                })

                const { location } = that.props;
                const { id } = location.state || {}; // 获取 URL 参数
                if (id) {
                    that.setState({
                        id: id,
                    })
                    that.loadMenu(tabIdx);
                }

                that.setState({
                    tabList: arry,
                })
            } else {
                Toast.show({ icon: 'fail', content: '加载头部菜单异常！' });
            }
        })

        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            return;
        }

        this.setState({
            userInfo: JSON.parse(user)
        })
    }

    insertPlanetFamilyGroup = () => {
        var that = this;
        const { location } = that.props;
        const { id } = location.state || {}; // 获取 URL 参数

        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            that.insertPlanetFamilyGroup();
            return;
        }
        var openid = localStorage.getItem("openid")
        if (openid == null || openid == "" || openid == undefined) {
            that.insertPlanetFamilyGroup();
        } else {

            var planetId = localStorage.getItem("planetId");
            if (planetId == null || planetId == undefined || planetId == "" || planetId != id) 
            {
                InsertPlanetFamilyGroup({
                    PlanetId: id,
                    OpenId: openid,
                }).then(res => {
                    localStorage.setItem("planetId", id);
                    if (res.success) {
    
                    }
                })
            }
        }
    }

    loadMenu = (tabIdx) => {
        var that = this;

        const { location } = that.props;
        const { id } = location.state || {}; // 获取 URL 参数
        if (id) {

            const data = {
                PlanetId: id,
                MaxResultCount: 999,
                SkipCount: 0,
                TabTypeId: tabIdx === 0 ? undefined : tabIdx
            };
            PostAlbumClass(data).then(res => {
                if (res.success) {
                    var list = [];
                    var navIdx = 0;
                    res.result.map((item, index) => {
                        if (index == 0) {
                            if (tabIdx == 478) {
                                that.setState({
                                    byIdx: item.id
                                })
                            }
                            that.setState({
                                navIdx: item.id
                            })
                            navIdx = item.id;
                        }
                        list.push({
                            id: item.id,
                            name: item.name,
                        })
                    })
                    if (tabIdx == 477) {
                        navIdx = 0;
                    }
                    that.setState({
                        tabTypes: list,
                        navIdx: navIdx,
                    })

                    that.loadAlbums(navIdx);
                } else {
                    Toast.show({ icon: 'fail', content: '加载左侧菜单异常！' });
                }
            })
        }
    }


    loadAlbums = async (navIdx) => {
        const { location } = this.props;
        const { id } = location.state || {}; // 获取 URL 参数

        var that = this;
        const { page, pageSize, tabIdx, loading, hasMore, initialLoading } = this.state;
        if (!initialLoading && (loading || !hasMore)) return;

        this.setState({ loading: true });

        const data = {
            PlanetId: id,
            OpenId: "",
            MaxResultCount: pageSize,
            SkipCount: page * pageSize,
            photoTypeId: navIdx == 0 ? null : navIdx
        };
        if (navIdx == 0) {
            data.TabTypeId = 477;
        }

        try {
            PostAlbums(data).then(res => {
                if (res.success) {
                    var newPosts = res.result.items || [];
                    var imgList=[];
                    var imgListQNY=[];
                    newPosts.map(item => {
                        if (item.headImg != null) {
                            if (item.headImg.indexOf("https://") > -1) {
                                var urls = item.headImg.split("https://").filter(Boolean);
                                item.headImg = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
                            } else {
                                item.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item.headImg;
                                // item.headImg = environment.QNYImgUrl + item.headImg + environment.QNYImgUrlYS;
                            }
                        }
                        var list = [];
                        var listQNY = [];
                        var isAdmin = false;
                        if (that.state.isAdmin) {
                            isAdmin = true;
                        } else {
                            if (item.openId == localStorage.getItem("openid")) {
                                isAdmin = true;
                            }
                        }
                        item.imgs.map(item1 => {
                            if (item1.indexOf("https://") > -1 || item1.indexOf("http://") > -1) {
                                list.push(item1.replace("https", "http"))
                                imgList.push({
                                    url: item1.replace("https", "http"),
                                    isAdmin: isAdmin
                                })

                                listQNY.push(item1.replace("https", "http"))
                                imgListQNY.push({
                                    url: item1.replace("https", "http"),
                                    isAdmin: isAdmin
                                })
                            } else {
                                const pathSegments = item1.split('/');
                                var fileName = pathSegments.filter(segment => segment).pop();
                                // var qnyUrl = environment.QNYImgUrl + fileName + environment.QNYImgUrlYS;
                                var qnyUrl = environment.apiEndpoint + item1;

                                listQNY.push(qnyUrl)
                                imgListQNY.push({
                                    url: qnyUrl,
                                    isAdmin: isAdmin
                                })

                                var url = environment.apiEndpoint + item1;
                                // var url = environment.QNYImgUrl + fileName;
                                list.push(url)
                                imgList.push({
                                    url: url,
                                    isAdmin: isAdmin
                                })
                                
                            }
                        })
                        item.imgs = list;
                        item.imgQNYs = listQNY;
                        item.msgCount = item.userActionDto
                            .filter(action => action.type === 2 && action.albumUserActionId == null).length;
                    })
                    const totalCount = res.result.totalCount || 0;
                    const currentHasMore = (page * pageSize) < totalCount;
                    that.setState({
                        albums: [...this.state.albums, ...newPosts],
                        imgList: [...this.state.imgList, ...imgList],
                        imgListQNY: [...this.state.imgListQNY, ...imgListQNY],
                        totalCount: totalCount,
                        page: page + 1,
                        hasMore: currentHasMore,
                        initialLoading: false,
                        dataLoading: false,
                        loading: false
                    });
                } else {
                    Toast.show({ icon: 'fail', content: '加载相册信息异常！' });
                }
            })
        } catch (error) {
            Toast.show({ icon: 'fail', content: '加载相册信息异常！' });
            console.error('加载留言失败:', error);
            this.setState({
                dataLoading: false,
                initialLoading: false, loading: false
            });
        }
    }

    render() {

        const showDialog = (item) => {
            Dialog.show({
                title: (
                    <div style={{
                        textAlign: 'center',
                        fontSize: 18,
                        color: '#595959',
                        padding: '8px 0',
                        marginTop: "25px",
                        fontFamily: '"STKaiti", "KaiTi", serif' // 楷体字体
                    }}>
                        <ExclamationCircleFill style={{
                            color: '#ff4d4f',
                            fontSize: 24,
                            marginRight: 8
                        }} />
                        确认删除此照片吗？
                </div>
                ),
                content: (
                    <div style={{
                        textAlign: 'center',
                        color: '#8c8c8c',
                        padding: '12px 0 16px',
                        fontSize: 14,
                        paddingBottom: "10px",
                        paddingTop: "0px",
                        fontFamily: '"STKaiti", "KaiTi", serif'
                    }}>
                        删除后将无法恢复
                </div>
                ),
                actions: [
                    [
                        {
                            key: 'cancel',
                            text: (
                                <span style={{
                                    display: 'inline-block',
                                    width: '100%',
                                    color: '#8c8c8c',
                                    fontSize: 16,
                                    letterSpacing: 2,
                                    fontFamily: '"STKaiti", "KaiTi", serif'
                                }}>
                                    取 消
                      </span>
                            ),
                            style: {
                                borderRight: '1px solid #f0f0f0'
                            },
                            onClick: () => {
                                console.log('回忆已随风消散...')
                                Dialog.clear()
                            }
                        },
                        {
                            key: 'delete',
                            text: (
                                <span style={{
                                    display: 'inline-block',
                                    width: '100%',
                                    color: '#ff4d4f',
                                    fontSize: 16,
                                    letterSpacing: 2,
                                    fontWeight: 'bold',
                                    fontFamily: '"STKaiti", "KaiTi", serif'
                                }}>
                                    删 除
                      </span>
                            ),
                            onClick: () => {
                                const pathSegments = item.split('/');
                                // 取最后一个非空片段
                                var fileName = pathSegments.filter(segment => segment).pop();
                                console.log(fileName);

                                var that = this;
                                DelAlbumImgById(fileName).then(res => {
                                    if (res.success) {
                                        if (res.result) {
                                            that.setState({
                                                albums: [],
                                                imgList: [],
                                                imgListQNY: [],
                                                page: 0,
                                                hasMore: true
                                            })
                                            that.loadMenu(that.state.tabIdx);
                                        }
                                    }
                                })
                            }
                        }
                    ]
                ],
                style: {
                    '--border-radius': '12px',
                    '--max-width': '280px',
                    '--adm-font-size-main': '16px'
                },
                bodyStyle: {
                    padding: 0
                },
                closeOnMaskClick: true,  // 新增这行，点击遮罩层可关闭
                closeOnAction: true     // 确保点击按钮后也关闭
            })
        }

        return (
            <div style={{ height: "100%", width: "100%", overflow: "auto" }}>
                <NavBar back='返回' onBack={() => {
                    this.props.navigate('/home?planetId=' + this.state.id, { replace: true, state: { id: this.state.id } }); // 传递状态
                }} style={{ 'border-bottom': 'solid 1px #e4e4e4', 'height': "6%" }}>
                    相册分类列表
                </NavBar>


                <div style={{ backgroundColor: "rgb(234 234 234)", height: "85%" }}>
                    <div style={{
                        backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/34-10.png')"
                        , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "6%",
                        display: "flex", flexDirection: "row"
                    }}>
                        {
                            this.state.tabList.map(item => {
                                return (
                                    <div style={{
                                        width: "90px", height: "100%", backgroundRepeat: "no-repeat", backgroundSize: "100% 100%",
                                        backgroundImage: this.state.tabIdx == item.id ? "url('https://api.weibinyi.com/images/niannian/4/34-09.png')" : ""
                                        , textAlign: "center", lineHeight: "41px", color: "#fff", fontSize: "15px"
                                    }} onClick={() => {
                                        this.setState({
                                            tabIdx: item.id,
                                            albums: [],
                                            imgList: [],
                                            imgListQNY: [],
                                            page: 0,
                                            hasMore: true
                                        })
                                        this.loadMenu(item.id);
                                    }}>
                                        {item.name}
                                    </div>
                                )
                            })
                        }
                    </div>

                    <div style={{ display: "flex", flexDirection: "row", height: "93%" }}>
                        <div style={{
                            width: "90px", height: "100%", backgroundRepeat: "no-repeat", backgroundSize: "100% 100%",
                            backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/34-13.png')", textAlign: "center"
                            , display: "flex", flexDirection: "column"
                        }}>

                            {
                                this.state.tabIdx == 477 ?
                                    <div style={{
                                        width: "100%", height: "40px", backgroundRepeat: "no-repeat", backgroundSize: "100% 100%",
                                        backgroundImage: this.state.navIdx == 0 ?
                                            "url('https://api.weibinyi.com/images/niannian/4/34-14.png')" : ""
                                        , marginTop: "25px", textAlign: "center", lineHeight: "40px", color: "#000",
                                        fontSize: "13px", fontWeight: "600"
                                    }} onClick={() => {
                                        this.setState({
                                            navIdx: 0,
                                            albums: [],
                                            imgList: [],
                                            imgListQNY: [],
                                            page: 0,
                                            hasMore: true
                                        }, () => {
                                            this.loadAlbums(0);
                                        })
                                    }}>
                                        所有
                                    </div> : null
                            }
                            

                            {
                                this.state.tabTypes.map(item => {
                                    return (<div style={{
                                        width: "100%", height: "40px", backgroundRepeat: "no-repeat", backgroundSize: "100% 100%",
                                        backgroundImage: this.state.navIdx == item.id ?
                                            "url('https://api.weibinyi.com/images/niannian/4/34-14.png')" : ""
                                        , marginTop: "25px", textAlign: "center", lineHeight: "40px", color: "#000",
                                        fontSize: "13px", fontWeight: "600"
                                    }} onClick={() => {
                                        this.setState({
                                            navIdx: item.id,
                                            albums: [],
                                            imgList: [],
                                            imgListQNY: [],
                                            page: 0,
                                            hasMore: true
                                        }, () => {
                                            this.loadAlbums(item.id);
                                        })
                                    }}>
                                        {item.name}
                                    </div>)
                                })
                            }


                            {
                                this.state.isAdmin ?
                                    <div style={{
                                        width: "100%", height: "70px", backgroundRepeat: "no-repeat", backgroundSize: "100% 100%",
                                        backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/34-14.png')"
                                        , textAlign: "center", lineHeight: "40px", color: "#000", marginTop: "auto",
                                        fontSize: "13px", fontWeight: "600", marginBottom: "10px"
                                    }} onClick={() => {
                                        this.props.navigate('/albumEdit', { replace: true, state: { id: this.state.id } }); // 传递状态
                                    }}>
                                        <div style={{ margin: "13px 0px 6px 0px", display: "flex", justifyContent: "center" }}>
                                            <Image src={"https://api.weibinyi.com/images/niannian/4/34-16.png"} fit='fill'
                                                width={20} height={20} />
                                        </div>
                                        <div style={{ lineHeight: "20px", color: "#777" }}>
                                            编辑
                                        </div>
                                    </div> : null
                            }

                            <div style={{
                                width: "100%", height: "70px", backgroundRepeat: "no-repeat", backgroundSize: "100% 100%",
                                backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/34-09.png')"
                                , textAlign: "center", lineHeight: "40px", color: "#000", 
                                marginTop: this.state.isAdmin ? "0" : "auto",
                                fontSize: "13px", fontWeight: "600"
                            }} onClick={() => {
                                this.props.navigate('/albumUpload', {replace: true, 
                                    state: {
                                        planetId: this.state.id,
                                        tabIdx: this.state.tabIdx,
                                        navIdx: this.state.navIdx,
                                    }
                                }); // 传递状态
                            }}>
                                <div style={{ margin: "13px 0px 6px 0px", display: "flex", justifyContent: "center" }}>
                                    <Image src={"https://api.weibinyi.com/images/niannian/4/34-17.png"} fit='fill'
                                        width={20} height={20} />
                                </div>
                                <div style={{ lineHeight: "20px", color: "#fff" }}>
                                    上传
                                </div>
                            </div>

                        </div>

                        <div style={{
                            width: "78%", height: "100%", overflowY: "scroll"
                        }}>
                            {
                                this.state.tabIdx == 4780000 && this.state.byIdx == this.state.navIdx ?
                                    <div style={{ width: "94%", margin: "0 3%" }}>
                                        {/* 瀑布流容器 */}
                                        {
                                            this.state.albums == null || this.state.albums.length == 0 ? null :
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "flex-start"
                                                }}>
                                                    {/* 左列 */}
                                                    <div style={{ width: "49%" }}>
                                                        {this.state.albums[0].imgQNYs
                                                            .filter((_, index) => index % 2 === 0)
                                                            .map((item, index) => (
                                                                <WaterfallItem2
                                                                    key={`left-${index}`}
                                                                    item={item}
                                                                    viewImg={(e) => {
                                                                        if (this.state.isClosing) {
                                                                            return;
                                                                        }
                                                                        this.setState({
                                                                            visible1: true,
                                                                            demoImages: this.state.albums[0].imgs,
                                                                            imgIndex: index * 2,
                                                                        })
                                                                    }}
                                                                />
                                                            ))}
                                                    </div>

                                                    {/* 右列 */}
                                                    <div style={{ width: "49%" }}>
                                                        {this.state.albums[0].imgQNYs
                                                            .filter((_, index) => index % 2 === 1)
                                                            .map((item, index) => (
                                                                <WaterfallItem2
                                                                    key={`right-${index}`}
                                                                    item={item}
                                                                    viewImg={(e) => {
                                                                        if (this.state.isClosing) {
                                                                            return;
                                                                        }
                                                                        this.setState({
                                                                            visible1: true,
                                                                            demoImages: this.state.albums[0].imgs,
                                                                            imgIndex: (index * 2) + 1,
                                                                        })
                                                                    }}
                                                                />
                                                            ))}
                                                    </div>
                                                </div>
                                        }
                                        
                                        <div style={{ clear: "both", paddingTop: 16 }}>
                                            {
                                                this.state.albums.length == 0 ?
                                                    <div style={{ textAlign: 'center', color: '#999', marginBottom: "22%" }}>
                                                        没有更多信息了
                                                    </div> : ""
                                            }
                                        </div>
                                    </div> :
                                    <div style={{ width: "94%", margin: "0 3%" }}>
                                        {/* 瀑布流容器 */}
                                        <div style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "flex-start"
                                        }}>
                                            {/* 左列 */}
                                            <div style={{ width: "49%" }}>
                                                {this.state.imgListQNY
                                                    .filter((_, index) => index % 2 === 0)
                                                    .map((item, index) => (
                                                        <WaterfallItem3
                                                            key={`left-${index}`}
                                                            item={item}
                                                            navigate={this.props.navigate}
                                                            planetId={this.state.id}
                                                            viewImg={(e) => {
                                                                if (this.state.isClosing) {
                                                                    return;
                                                                }
                                                                this.setState({
                                                                    visible1: true,
                                                                    demoImages: this.state.imgList.map(item => item.url),
                                                                    imgIndex: index * 2,
                                                                })
                                                            }}
                                                            handleDelete={() => {
                                                                var url = this.state.imgList[(index * 2)].url;
                                                                showDialog(url);
                                                            }}
                                                        />
                                                    ))}
                                            </div>

                                            {/* 右列 */}
                                            <div style={{ width: "49%" }}>
                                                {this.state.imgListQNY
                                                    .filter((_, index) => index % 2 === 1)
                                                    .map((item, index) => (
                                                        <WaterfallItem3
                                                            key={`right-${index}`}
                                                            item={item}
                                                            navigate={this.props.navigate}
                                                            planetId={this.state.id}
                                                            viewImg={(e) => {
                                                                if (this.state.isClosing) {
                                                                    return;
                                                                }
                                                                this.setState({
                                                                    visible1: true,
                                                                    demoImages: this.state.imgList.map(item => item.url),
                                                                    imgIndex: (index * 2) + 1,
                                                                })
                                                            }}
                                                            handleDelete={() => {
                                                                var url = this.state.imgList[(index * 2) + 1].url;
                                                                showDialog(url);
                                                            }}
                                                        />
                                                    ))}
                                            </div>
                                        </div>

                                        {/* 加载更多 */}
                                        <div style={{ clear: "both", paddingTop: 16 }}>
                                            {this.state.page !== 0 && (
                                                <InfiniteScroll
                                                    loadMore={this.state.loadPosts}
                                                    hasMore={this.state.hasMore}
                                                    threshold={50}
                                                    initialLoad={false}
                                                >
                                                    {this.state.loading && (
                                                        <div style={{
                                                            textAlign: 'center',
                                                            padding: "16px 0",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center"
                                                        }}>
                                                            <DotLoading color="primary" />
                                                            <span style={{ marginLeft: 8 }}>加载中...</span>
                                                        </div>
                                                    )}
                                                    {!this.state.hasMore && (
                                                        <div style={{
                                                            textAlign: 'center',
                                                            color: '#999',
                                                            padding: "16px 0"
                                                        }}>
                                                            已经到底了
          </div>
                                                    )}
                                                </InfiniteScroll>
                                            )}
                                        </div>
                                    </div>

                            }
                            {
                                this.state.dataLoading ?
                                    <div style={{ clear: "both", paddingTop: 16 }}>
                                        <div style={{ textAlign: 'center' }}>
                                            <DotLoading color="primary" />
                                            <span style={{ marginLeft: 8 }}>加载中...</span>
                                        </div>
                                    </div> : ""
                            }
                        </div>
                    </div>


                </div>


                {
                    this.state.visible1 ?
                        <ImageViewer.Multi
                            images={this.state.demoImages}
                            visible={this.state.visible1}
                            defaultIndex={this.state.imgIndex}
                            onClose={() => {
                                // 标记为正在关闭
                                this.setState({ isClosing: true, visible1: false }, () => {
                                    // 短暂延迟后重置标记，避免影响正常打开
                                    setTimeout(() => {
                                        this.setState({ isClosing: false });
                                    }, 300);
                                });
                            }}
                        /> : null
                }

                <BottomMenu  position="absolute" selectKey="home" />

            </div>
        )
    }
}

export default withNavigate(Index);